<template>
  <RedesignWebccDropdown
    v-model="sorting"
    :options="SORT_OPTIONS"
    :mode
    :class="{ 'bg-thm-light': sorting !== SORT_DEFAULT }"
    :disabled
  >
    <template #button="{ details: key }">
      <div class="pr-3 truncate">
        {{ $t(`${trPrefix}prefix`) }}
        {{ $t(`${trPrefix}${key}` as TranslationKey) }}
      </div>
    </template>

    <template #option="{ details: key }">
      {{ $t(`${trPrefix}${key}` as TranslationKey) }}
    </template>
  </RedesignWebccDropdown>
</template>

<script setup lang="ts">
import type { Mode } from './RedesignWebccDropdown.vue'

const trPrefix = 'www.components.views.search.area.sorting.'

withDefaults(defineProps<{ mode?: Mode; disabled?: boolean }>(), {
  mode: 'fit',
})

const model = defineModel<SortingValue>()

const tracking = useTracking()

const sorting = computed({
  get: () => model.value ?? SORT_DEFAULT,
  set: (value) => {
    model.value = value === SORT_DEFAULT ? undefined : value
    tracking.handlers?.redesignFilters.sort(value)
  },
})
</script>
